import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { DrilldownFormsService } from '../../services/drilldown-forms.service';
import { CommonService } from '../../services/common.service';
import { ReportsService } from 'src/app/services/reports.service';

@Component({
  selector: 'send-file-action-button',
  template: `
    <button class="custom-button" vrm-button *ngIf="canSend" (click)="triggerSendButtonAction()">
      {{ translatedActionValue | uppercase }}
    </button>

    <span *ngIf="!canSend">{{ value }}</span>
  `,
  styles: [],
})
export class SendFileActionButtonComponent implements ICellRendererAngularComp {
  private selectedRowData: { pin?: unknown };

  public value: string;
  public translatedActionValue: string;
  public canSend: boolean = false;

  constructor(
    private dfService: DrilldownFormsService,
    private cService: CommonService,
    private rptService: ReportsService
  ) {}

  agInit(params: ICellRendererParams) {
    this.selectedRowData = params.data;
    this.value = params.value;

    if (
      this.cService.userProfile.userPermissions.permProfileInsightsSendPdfs &&
      this.cService.userProfile.userPermissions.permProfileInsightsSendPdfs === this.cService.permLevels.TRUE
    ) {
      if (this.value && this.value.toLowerCase() === 'send') {
        this.canSend = true;
        this.translatedActionValue = this.cService.readyTranslations.generic.send;
      }
    }
  }

  triggerSendButtonAction() {
    setTimeout(() => {
      const pins = [this.selectedRowData.pin];
      this.dfService.sendFileViaServer(
        this.dfService.currentInsightDetail.id,
        pins,
        this.rptService.requestedServerFilters.vehicle
      );
    }, 100); // <-- Wait for selectedRow to be up-to-date
  }

  refresh(): boolean {
    return false;
  }
}
